import { configuratorBuilder } from 'element-domain'

import { createConfiguratorInterface } from '@salsita-ai/platform-project-sdk/configurator'

export const configuratorInterface = createConfiguratorInterface(configuratorBuilder)
